import axios from 'axios';
import { TreatmentFilter } from './models';

const service = axios.create({
	baseURL: location.origin + '/api/ajax/Treatment/'
});

export default {
	/**
	 *
	 * @returns
	 */
	async GetTreatments() {
		const result = await axios.get('/api/ajax/Treatment/GetTreatments');
		switch (Object(result.data).ResponseCode) {
			case 200:
			case 204:
				return result.data.Array.map(category => new TreatmentFilter(category));

			default:
				return [];
		}
	},
	async GetTreatment(url) {
		const result = await axios.get('/api/ajax/Treatment/GetTreatment', { params: { url: url } });
		switch (Object(result.data).ResponseCode) {
			case 200:
				return result.data.Dto;

			default:
				return {};
		}
	},
	async GetAreasByTreatmentUrl(url) {
		const result = await axios.get('/api/ajax/Treatment/GetAreasByTreatmentUrl', { params: { url: url } });
		switch (Object(result.data).ResponseCode) {
			case 200:
				return result.data.Array;

			default:
				return [];
		}
	}
};
